import { render, staticRenderFns } from "./SidebarDefault.vue?vue&type=template&id=4ed53af4&"
import script from "./SidebarDefault.vue?vue&type=script&lang=js&"
export * from "./SidebarDefault.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDefault.vue?vue&type=style&index=0&id=4ed53af4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports